export default "__VITE_ASSET__DZtIPjrf__"